import { Component, OnInit, OnDestroy, ChangeDetectorRef, EventEmitter, ElementRef, OnChanges, SimpleChanges, Input, Output } from '@angular/core';
import { VendorConstant } from '../../constants/vendor.constant';
import { AppMainService } from 'src/app/app-main.service';
import { MessageService } from 'primeng/api';
import { VendorConfigService } from './services/vendor-config.service';
import { AccountUserService } from 'src/app/service/account.service';
import { ChildWindowFeature } from '../../constants/user-actions.constant';
import { ProfileService } from 'src/app/profile/profileService';

@Component({
    selector: 'app-config-external-client',
    templateUrl: './config-external-client.component.html'
})

export class ConfigExternalClientComponent implements OnChanges {

    @Input() displayConfigExternalClient: boolean = false;
    @Input() vendorCategoryId: number;
    @Input() initialCalerdarListCount: number;

    @Output() modalCloseHandler = new EventEmitter();
    @Output() onCalendarConfigCompleted = new EventEmitter();

    configList: Array<any>;
    configHeader: string;
    windowRef = null;

    constructor(
        public appMainService: AppMainService,
        private messageService: MessageService,
        private vendorConfigService: VendorConfigService,
        private accountService: AccountUserService,
        private profileService: ProfileService
    ){

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayConfigExternalClient && changes.displayConfigExternalClient.currentValue == true){
            if (this.vendorCategoryId == VendorConstant.CalendarCategoryId){
                this.getVendorConfig(this.vendorCategoryId);
                this.configHeader = VendorConstant.CalendarCategoryHeader;
            }
        }
    }

    getVendorConfig(categoryId: number): void {
        this.appMainService.isShowSpinner('getVendorConfig');
        this.vendorConfigService.getVendorConfig(categoryId).subscribe(
            {
                next: (response) => {
                    this.configList = response || [];
                    this.appMainService.isHideSpinner('getVendorConfig');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getVendorConfig');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.message ? error?.error?.Message : 'Configuration are not loaded, please try again...'
                    });
                },
                complete: () => {

                },
            });
    }

    configureExternalClient(clientData): void {
        const loggedinUser = this.accountService.userValue;

        let userInfo = {
            organizationId: loggedinUser.organizationId,
            userId: loggedinUser.userId,
            vendorId: clientData?.vendorOAuthRegistration?.vendorId,
            clientIP: clientData?.vendorOAuthRegistration?.createdSource,
            loginAuditId: loggedinUser.loginAuditId,
            authToken: loggedinUser.token,
            sessionId: localStorage.getItem("randomstr"),
            sourceType: "Web"
        };

        let objEncStr = btoa(JSON.stringify(userInfo));
        let url = "";

        if (clientData?.name === "OutlookCalender"){
            url = this.generateOutlookCalendarUrl(clientData?.vendorOAuthRegistration, objEncStr);
        }

        this.windowRef = window.open(
            url,
            "child",
            ChildWindowFeature
        );

        let windowInterval = setInterval(() => {
            this.profileService.getRegisteredCalenderConfig(clientData?.vendorOAuthRegistration?.id).subscribe(
                {
                    next: (response) => {
                        if (response.length > this.initialCalerdarListCount){
                            if (this.windowRef) {
                                this.windowRef.close();
                            }
                            clearInterval(windowInterval);
                            this.displayConfigExternalClient = false;
                            this.onCalendarConfigCompleted.emit();
                        }
                        if (this.windowRef.closed){
                            clearInterval(windowInterval);
                        }
                    },
                    error: (error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.Message : 'Calendar list are not loaded, please try again...'
                        });
                    },
                    complete: () => {
        
                    },
                });
        }, 500)
    }

    generateOutlookCalendarUrl(urlObject, userObject): string {
        return `${urlObject.registrationURL}client_id=${urlObject.clientId}&redirect_uri=${urlObject.redirectURL}&response_type=code&scope=openid+offline_access+profile+User.Read+Calendars.ReadWrite&state=${userObject}&prompt=select_account`;
    }

    closeConfigModal(): void {
        this.displayConfigExternalClient = false;
        this.modalCloseHandler.emit();
    }
}